import { render, staticRenderFns } from "./SynergismBigCrunchButton.vue?vue&type=template&id=f67e95c6&scoped=true&"
import script from "./SynergismBigCrunchButton.vue?vue&type=script&lang=js&"
export * from "./SynergismBigCrunchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67e95c6",
  null
  
)

export default component.exports